import type { NotificationPreferences } from '@/lib/api/common/notification-preferences-api'
import { PartnerPayoutScheduleType } from './partner.interface'

export enum ScholarLevel {
    FUNDAMENTAL = 'FUNDAMENTAL',
    MEDIO = 'MEDIO',
    TECNICO = 'TECNICO',
    SUPERIOR = 'SUPERIOR',
    POS_GRADUACAO = 'POS_GRADUACAO',
    MESTRADO = 'MESTRADO',
    DOUTORADO = 'DOUTORADO',
    POS_DOUTORADO = 'POS_DOUTORADO',
}

export enum DocumentType {
    CPF = 'CPF',
    CNPJ = 'CNPJ',
}

export interface ProfessionalUser {
    id: number
    email: string
    name: string
    active: boolean
    hasPassword?: boolean
    pendingSetup?: boolean
    roleId?: number | null
}

export interface Professional {
    /**
     * Canais por onde esta entidade aceita ser notificada. Ausente = nada: só recebe
     * quem consentiu. Ver `notification-preferences-api.ts`.
     */
    notificationPreferences?: NotificationPreferences | null
    id: number
    name: string
    email?: string
    phoneNumber?: string
    whatsAppNumber?: string
    phone2?: string
    phone3?: string
    formation?: string
    scholarLevel?: ScholarLevel
    document?: string
    documentType?: DocumentType
    registrationNumber?: string
    councilName?: string
    createUser?: boolean
    photoUrl?: string
    street?: string
    number?: string
    complement?: string
    neighborhood?: string
    city?: string
    state?: string
    zipCode?: string
    country?: string
    partnerId?: number | null
    partner?: {
        id: number
        name: string
        tradingName?: string
    } | null
    organizationId: number
    userId?: number
    user?: ProfessionalUser
    createdAt: string
    updatedAt: string
    specialties?: Array<{
        id: number
        consultationPrice?: number | null
        maxDiscount?: number | null
        specialty: {
            id: number
            name: string
            parentId?: number | null
            parent?: { id: number; name: string } | null
        }
    }>
    hospitals?: Array<{
        id: number
        hospital: {
            id: number
            name: string
        }
    }>
    establishments?: Array<{
        id: number
        establishment: {
            id: number
            name: string
        }
    }>
    titles?: Array<{
        id: number
        title: string
    }>
    qualifications?: Array<{
        id: number
        description: string
    }>
    payoutScheduleType?: PartnerPayoutScheduleType
    payoutFixedDay?: number | null
    payoutDaysAfterAppointment?: number | null
}
